import { Link } from "react-router-dom";
import { PackageCatalog } from "../models/PackageCatalog.js";

const catalog = PackageCatalog.launch();

export function PackagesSection() {
  return (
    <section className="t-packages" data-section="packages">
      <header className="t-highlights-head">
        <h2 className="t-section-title">Packages</h2>
        <p className="t-section-lead">Launch prices, per product. Pick one or ask for a custom mix.</p>
      </header>
      <ul className="t-price-list">
        {catalog.all().map((p) => (
          <li key={p.id} className="t-price-row">
            <div>
              <h3>{p.name}</h3>
              <p>{p.summary}</p>
            </div>
            <p className="t-price">{p.priceLabel()}</p>
            <Link to={`/quote?package=${p.id}`} className="t-btn t-btn-secondary">
              Quote
            </Link>
          </li>
        ))}
      </ul>
      <p className="t-note">
        <Link to="/packages">Full details and turnaround</Link>
      </p>
    </section>
  );
}
